// extracted by mini-css-extract-plugin
export var logo = "_js-2";
export var logoWrapper = "_js-1";
export var strip = "_js-0";